import { Flex } from '@mantine/core';
import { Outlet } from 'react-router-dom';
import {NavbarSimple} from '../sidebar/sidebar';

function Layout() {
  return (
    <Flex h="100vh">
      <NavbarSimple />
      <div style={{ flex: 1, padding: 16 }}>
        <Outlet /> {}
      </div>
    </Flex>
  );
}

export default Layout;
